// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "element_feedback_option_id": {
      "column": {
        "default": null,
        "name": "element_feedback_option_id",
        "null": false,
        "type": "uuid"
      },
      "name": "element_feedback_option_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "FeedbackAnswer",
  "collectionKey": "feedback_answers",
  "collectionName": "feedback_answers",
  "i18nKey": "feedback_answer",
  "camelizedLower": "feedbackAnswer",
  "name": "FeedbackAnswer",
  "nameDasherized": "feedback-answer",
  "pluralName": "feedback_answers",
  "ransackable_associations": [
    {
      "className": "ElementFeedbackOption",
      "collectionName": "element_feedback_options",
      "foreignKey": "element_feedback_option_id",
      "name": "element_feedback_option",
      "macro": "belongs_to",
      "resource_name": "ElementFeedbackOption",
      "through": null
    },
    {
      "className": "FeedbackElement",
      "collectionName": "feedback_elements",
      "foreignKey": "feedback_element_id",
      "name": "feedback_element",
      "macro": "belongs_to",
      "resource_name": "FeedbackElement",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "element_feedback_option_id",
      "column": {
        "default": null,
        "name": "element_feedback_option_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "feedback_element_id",
      "column": {
        "default": null,
        "name": "feedback_element_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_element_feedback_option_id",
      "column": {
        "default": null,
        "name": "old_element_feedback_option_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_feedback_element_id",
      "column": {
        "default": null,
        "name": "old_feedback_element_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [],
  "paramKey": "feedback_answer",
  "primaryKey": "id"
}

/** Frontend model for FeedbackAnswer. */
export default class FeedbackAnswer extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  elementFeedbackOptionId() {
    return this.readAttributeUnderscore("element_feedback_option_id")
  }

  /** @returns {boolean} */
  hasElementFeedbackOptionId() {
    const value = this.elementFeedbackOptionId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }
}
